module.exports = __webpack_public_path__ + "static/img/034 5.ec7c78b6.jpg";